import React, { CSSProperties, FC, ReactNode, RefObject } from 'react';
import cn from 'classnames';
import { Image } from '../Image';
import { Favorite } from '../Favorite';
import { Rating } from '../Rating';
require("./ProductThumbnail.css");
var styles = {
  "Root": "ProductThumbnail-module-Root_Psa",
  "Rating": "ProductThumbnail-module-Rating_20r",
  "Favorite": "ProductThumbnail-module-Favorite_3Gt",
  "TopRightComponent": "ProductThumbnail-module-TopRightComponent_kPM",
  "BottomRightComponent": "ProductThumbnail-module-BottomRightComponent_1sV",
  "Bg": "ProductThumbnail-module-Bg_2VF",
  "Image": "ProductThumbnail-module-Image_2mC",
  "flexibleHeight": "ProductThumbnail-module-flexibleHeight_2zs",
  "disabled": "ProductThumbnail-module-disabled_MYs"
};
export const ProductThumbnail = ({
  imageSrc,
  imageAlt,
  rating,
  onChangeFavorite,
  isFavorite,
  isFlexibleHeight = false,
  disabled = false,
  bg = '#f6f7fa',
  borderColor = 'transparent',
  topRightComponent,
  bottomRightComponent,
  className,
  style,
  innerRef,
  controlRef
}) => {
  return /*#__PURE__*/React.createElement("div", {
    ref: innerRef || controlRef,
    className: cn(styles.Root, {
      [styles.flexibleHeight]: isFlexibleHeight,
      [styles.disabled]: disabled
    }, className),
    style: {
      ...style,
      borderColor
    }
  }, topRightComponent && /*#__PURE__*/React.createElement("div", {
    className: styles.TopRightComponent
  }, topRightComponent), bottomRightComponent && /*#__PURE__*/React.createElement("div", {
    className: styles.BottomRightComponent
  }, bottomRightComponent), /*#__PURE__*/React.createElement("div", {
    className: styles.Favorite
  }, /*#__PURE__*/React.createElement(Favorite, {
    isChecked: isFavorite,
    onClick: onChangeFavorite
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.Rating
  }, /*#__PURE__*/React.createElement(Rating, {
    value: rating,
    size: "s"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.Bg,
    style: {
      background: bg
    }
  }), /*#__PURE__*/React.createElement(Image, {
    src: imageSrc,
    alt: imageAlt,
    className: styles.Image
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ProductThumbnail.displayName = 'ProductThumbnail';
}